export default function Page(props) {
    return (
        <div className="h-full flex flex-col">
            <span className="loader"></span>
            {props.component}
        </div>
    )
}